import * as React from "react";
import { CountDownTimerNewDesign } from "./count-down-timer-new-design";
import { HotelLastSecondIcon } from "./hotel-last-second-icon";

export const HotelLastSecondDiscountBox: React.FC<{
  size?: "small" | "large" | "medium";
  loading?: boolean;
  onTimeEnd?(): void;
}> = ({ size = "small", loading, onTimeEnd }) => {
  if (size === "small") {
    return (
      <div className="flex h-[112px] w-[170px] flex-col items-center justify-center gap-1 rounded-lg border border-[#ED071A1A] bg-[linear-gradient(191.68deg,_#FCD9DD_-0.52%,_#F78894_46.11%,_#E92525_99.07%)] bg-clip-padding px-3">
        <HotelLastSecondIcon size={size} />
        <CountDownTimerNewDesign
          showTimer={!loading}
          resetOnEnd
          className="!mt-0"
          boxSize="small"
        />
      </div>
    );
  }

  if (size === "medium") {
    return (
      <div className="flex h-[60px] w-full items-center justify-between rounded-lg border border-[#ED071A1A] bg-[linear-gradient(177.07deg,_#FCD9DD_-19.34%,_#F78894_34.37%,_#E92525_95.4%)] bg-clip-padding px-4 md:pt-1">
        <HotelLastSecondIcon size={size} />
        <CountDownTimerNewDesign
          boxSize={"small"}
          className="!mt-0 !justify-end"
          onTimeEnd={onTimeEnd}
        />
      </div>
    );
  }

  return (
    <div className="mt-1 flex h-[98%] w-[200px] flex-col items-center justify-center rounded-2xl border border-[#ED071A1A] bg-[linear-gradient(191.68deg,_#FCD9DD_-0.52%,_#F78894_50.72%,_#E92525_99.07%)] bg-clip-padding">
      <HotelLastSecondIcon size={size} />
      <CountDownTimerNewDesign boxSize="large" onTimeEnd={onTimeEnd} />
    </div>
  );
};
